module.exports = __webpack_public_path__ + "img/3.ba0a9820.jpg";